/**
 * General utility helper functions
 */

/**
 * Safely parses a string to a positive integer, returning fallback if invalid
 * @param val - String value to parse (typically from URL params)
 * @param fallback - Default value to return if parsing fails
 * @returns Parsed integer or fallback
 * @example
 * safeInt('5', 1) // Returns 5
 * safeInt('abc', 1) // Returns 1 (fallback)
 * safeInt('-5', 1) // Returns 1 (negative not allowed)
 */
export const safeInt = (val: string | null, fallback: number): number => {
  const n = Number(val)
  return Number.isInteger(n) && n > 0 ? n : fallback
}

/**
 * Compares two arrays for equality (order-sensitive)
 * @param a - First array
 * @param b - Second array
 * @returns True if arrays have same length and all elements match at same index
 * @example
 * sameArray([1, 2, 3], [1, 2, 3]) // Returns true
 * sameArray([1, 2], [2, 1]) // Returns false (different order)
 * sameArray([], []) // Returns true
 */
export const sameArray = (a: (string | number)[] = [], b: (string | number)[] = []): boolean =>
  a.length === b.length && a.every((v, i) => v === b[i])
